import { AlertCircle, Home } from 'lucide-react';
import { Button } from '@client/components/ui/button';

interface MissingParametersErrorProps {
  onGoHome?: () => void;
}

export function MissingParametersError({ onGoHome }: MissingParametersErrorProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-primary-50">
      <div className="mx-auto max-w-md text-center">
        <div className="mb-4 flex justify-center">
          <AlertCircle className="h-12 w-12 text-amber-500" />
        </div>
        <h2 className="mb-2 text-xl font-semibold text-gray-900">
          Missing Information
        </h2>
        <p className="mb-6 text-gray-600">
          We couldn't find the required client or funding source information to
          display this page.
        </p>
        <div className="flex justify-center">
          {onGoHome && (
            <Button
              onClick={onGoHome}
              className="flex items-center gap-2"
            >
              <Home className="h-4 w-4" />
              Go to Dashboard
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}